import React from "react";

export default class ShopperGuideBlogs extends React.Component{
	render(){
		const margin_bottom = {
			marginBottom:"10px"
		};
		const padding_style = {
			padding:"15px"
		};
		const main_div_style = {
			backgroundColor: "#f9f9f9",
			padding: "15px"
		};
		return (<div style={main_div_style}>
			<div className="row text-center" style={margin_bottom}>
				<div className="col-sm-4">
					<div className="thumbnail" style={padding_style}>
						<img src="https://floorwalk.in/blog/wp-content/uploads/2014/12/Become-a-better-Mystery-Shopper-1-550x360.jpg" alt="Paris" width="350" height="175" />
						<div style={{backgroundColor: "#e1e6e9",padding: "25px"}}>
							<p><strong>MYSTERY SHOPPING: GET STARTED</strong></p>
							<p>While Mystery shopping can provide you with good pay by just working from the comfort of your home, it can be quite challenging to make the start. If you have just opted for <a href="https://floorwalk.in/blog/mystery-shopping-faq-getting-maximum-assignments/" target="__blank"><b>read more…</b></a></p>
						</div>
					</div>
				</div>
				<div className="col-sm-4">
					<div className="thumbnail" style={padding_style}>
						<img src="https://floorwalk.in/blog/wp-content/uploads/2017/06/pexels-photo-213663-1.jpeg" alt="Paris" width="350" height="175" />
						<div style={{backgroundColor: "#e1e6e9",padding: "25px"}}>
							<p><strong>HOW TO GET MAXIMUM MYSTERY SHOPPING ASSIGNMENTS</strong></p>
							<p>Mystery Shopping is as much as a responsibility, as it is an opportunity to grab some handy cash, or to get freebies. A mystery shopper <a href="https://floorwalk.in/blog/getting-started-with-mystery-shopping/" target="__blank"><b>read more…</b></a></p>
						</div>
					</div>
				</div>
				<div className="col-sm-4">
					<div className="thumbnail" style={padding_style}>
						<img src="https://floorwalk.in/blog/wp-content/uploads/2014/12/Mystery-Shopping-India.jpg" alt="Paris" width="350" height="175" />
						<div style={{backgroundColor: "#e1e6e9",padding: "25px"}}>
							<p><strong>MYSTERY SHOPPING AND ITS IMPACT | DOES MY…</strong></p>
							<p>Customer service is what keeps your clients coming back time and again. Your clients prefer you to your competitors when you provide them with <a href="https://floorwalk.in/blog/mystery-shopping-faq-audit-help-company/" target="__blank"><b>read more…</b></a></p>
						</div>
					</div>
				</div>
			</div>

			<div className="row text-center">
				<div className="col-sm-4">
					<div className="thumbnail" style={padding_style}>
						<img src="https://floorwalk.in/blog/wp-content/uploads/2014/12/Mystery-Shopper-Qualification-1-760x490.jpg" alt="Paris" width="350" height="175" />
						<div style={{backgroundColor: "#e1e6e9",padding: "25px"}}>
							<p><strong>WHO CAN BE A MYSTERY SHOPPER?</strong></p>
							<p>Mystery shopping is one of those jobs which requires part-time involvement. Of course, there are certain boundaries to what could be a shopper profile. Mystery audits have a certain <a href="https://floorwalk.in/blog/mystery-shopper-college-student-or-qualified-professional/" target="__blank"><b>read more…</b></a></p>
						</div>
					</div>
				</div>
				<div className="col-sm-4">
					<div className="thumbnail" style={padding_style}>
						<img src="https://floorwalk.in/blog/wp-content/uploads/2017/08/restaurant-691397_960_720-760x490.jpg" alt="Paris" width="350" height="175" />
						<div style={{backgroundColor: "#e1e6e9",padding: "25px"}}>
							<p><strong>MAKE MONEY THROUGH FREELANCING | A GUIDE TO…</strong></p>
							<p>You, read that right. Mystery shopping provides with opportunities to eat for free and if that wasn’t enough, it pays you for it. Though the pay structure of <a href="https://floorwalk.in/blog/eat-for-free-make-money-from-pennies-to-pounds/" target="__blank"><b>read more…</b></a></p>
						</div>
					</div>
				</div>
				<div className="col-sm-4">
					<div className="thumbnail" style={padding_style}>
						<img src="https://floorwalk.in/blog/wp-content/uploads/2017/06/pexels-photo-297755.jpeg" alt="Paris" width="350" height="175" />
						<div style={{backgroundColor: "#e1e6e9",padding: "25px"}}>
							<p><strong>HOW TO AVAIL FREE TRAVEL WITH MYSTERY SHOPPING?</strong></p>
							<p>Getting the benefit of a service or a product for free can certainly spring up many questions in one’s mind. In the contemporary age of the <a href="https://floorwalk.in/blog/is-free-travel-with-mystery-shopping-companies-a-scam/" target="__blank"><b>read more…</b></a></p>
						</div>
					</div>
				</div>
			</div>
		</div>);
	}
}
